module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7773575184610',
        variantId: ['43013375787234', '43013375820002', '43013375852770'],
        capacity: 2,
        productName: 'Kits Énergie 2 kWh',
        name: 'Kit "Starter" (2 kWh)',
        discountPrice: 3898,
        originalPrice: 4898,
        unit: '€',
        includes: ['Batterie LFP 2 kWh x1', 'Power Hub', 'Jeu de câbles'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7773575250146',
        variantId: ['43013375918306', '43013375951074', '43013375983842'],
        capacity: 4,
        productName: 'Kits Énergie 4 kWh',
        name: 'Kit "Starter" (4 kWh)',
        discountPrice: 5597,
        originalPrice: 7097,
        unit: '€',
        includes: ['Batterie LFP 2 kWh x2', 'Power Hub', 'Jeu de câbles'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7773575315682',
        variantId: ['43013376278754', '43013376311522', '43013376344290'],
        capacity: 5,
        productName: 'Kits Énergie 5 kWh',
        name: 'Kit "Starter" (5 kWh)',
        discountPrice: 5998,
        originalPrice: 7498,
        unit: '€',
        includes: ['Batterie LFP 5 kWh x1', 'Power Hub', 'Jeu de câbles'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7773575381218',
        variantId: ['43013376409826', '43013376442594', '43013376475362'],
        capacity: 10,
        productName: 'Kits Énergie 10 kWh',
        name: 'Kit "Starter" (10 kWh)',
        discountPrice: 9797,
        originalPrice: 12297,
        unit: '€',
        includes: ['Batterie LFP 5 kWh x2', 'Power Hub', 'Jeu de câbles'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7773575446754',
        variantId: ['43013376540898', '43013376573666', '43013376606434'],
        capacity: 15,
        productName: 'Kits Énergie 15 kWh',
        name: 'Kit "Starter" (15 kWh)',
        discountPrice: 13596,
        originalPrice: 17096,
        unit: '€',
        includes: ['Batterie LFP 5 kWh x3', 'Power Hub', 'Jeu de câbles'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: "Ma\xEEtrisez et visualisez votre consommation d'\xE9nergie.",
      discountPrice: 300,
      originalPrice: 538,
      unit: '€',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'Panneau de distribution intelligent AC/DC',
        desc: "Avec 12 positions DC fusibl\xE9es et 6 positions AC prot\xE9g\xE9es par AFCI, vous pouvez g\xE9rer la distribution de la puissance dans l'ensemble de votre camping-car ou de votre petite maison. Contr\xF4lez jusqu'\xE0 6 positions DC \xE0 partir de l'application EcoFlow ou de la console.",
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Panneau de distribution intelligent AC/DC',
          desc: "Avec 12 positions DC fusibl\xE9es et 6 positions AC prot\xE9g\xE9es par AFCI, vous pouvez g\xE9rer la distribution de la puissance dans l'ensemble de votre camping-car ou de votre petite maison. Contr\xF4lez jusqu'\xE0 6 positions DC \xE0 partir de l'application EcoFlow ou de la console.",
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: "Puissance d'entr\xE9es principale AC",
            value: '16 A max, 230 V, 3600 W'
          }, {
            key: "Puissance d'entr\xE9es principale DC",
            value: '70 A Max'
          }, {
            key: 'Sortie AC',
            value: '6 positions AC, 10 A max chacune'
          }, {
            key: 'Sortie DC',
            value: "12 positions DC fusibl\xE9es (6 positions contr\xF4lables via la console du Kit \xC9nergie et l'application)"
          }, {
            key: 'Température de fonctionnement ',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensions',
            value: '210 x 354 x 98 mm (hauteur x largeur x profondeur)'
          }, {
            key: 'Poids net',
            value: '2,6 kg'
          }, {
            key: 'Niveau de protection',
            value: 'IP21'
          }, {
            key: 'Tests et certifications',
            value: 'CE, UL, FCC, EMC classe B'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: 'Sangle de montage de batterie',
        desc: 'Installez vos batteries en toute sécurité.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: "Ajoutez de la puissance, contr\xF4lez votre syst\xE8me et surveillez la consommation d'\xE9nergie.",
      discountPrice: 1600,
      originalPrice: 2355,
      unit: '€',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: 'Panneau de distribution intelligent AC/DC',
        desc: "Avec 12 positions DC fusibl\xE9es et 6 positions AC prot\xE9g\xE9es par AFCI, vous pouvez g\xE9rer la distribution de la puissance dans l'ensemble de votre camping-car ou de votre petite maison. Contr\xF4lez jusqu'\xE0 6 positions DC \xE0 partir de l'application EcoFlow ou de la console.",
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Panneau de distribution intelligent AC/DC',
          desc: "Avec 12 positions DC fusibl\xE9es et 6 positions AC prot\xE9g\xE9es par AFCI, vous pouvez g\xE9rer la distribution de la puissance dans l'ensemble de votre camping-car ou de votre petite maison. Contr\xF4lez jusqu'\xE0 6 positions DC \xE0 partir de l'application EcoFlow ou de la console.",
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: "Puissance d'entr\xE9es principale AC",
            value: '16 A max, 230 V, 3600 W'
          }, {
            key: "Puissance d'entr\xE9es principale DC",
            value: '70 A Max'
          }, {
            key: 'Sortie AC',
            value: '6 positions AC, 10 A max chacune'
          }, {
            key: 'Sortie DC',
            value: "12 positions DC fusibl\xE9es (6 positions contr\xF4lables via la console du Kit \xC9nergie et l'application)"
          }, {
            key: 'Température de fonctionnement ',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensions',
            value: '210 x 354 x 98 mm (hauteur x largeur x profondeur)'
          }, {
            key: 'Poids net',
            value: '2,6 kg'
          }, {
            key: 'Niveau de protection',
            value: 'IP21'
          }, {
            key: 'Tests et certifications',
            value: 'CE, UL, FCC, EMC classe B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: 'Console pour Kit Énergie EcoFlow',
        desc: "Contr\xF4lez, surveillez et visualisez votre consommation d'\xE9nergie.",
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: 'Console pour Kit Énergie EcoFlow',
          desc: "Contr\xF4lez, surveillez et visualisez votre consommation d'\xE9nergie.",
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: 'Écran tactile (mesure en diagonale)',
            value: '7 pouces (154,21 x 85,92 mm) (largeur x hauteur)'
          }, {
            key: "Tension d'alimentation",
            value: '12 VCC'
          }, {
            key: 'Température de fonctionnement',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensions',
            value: '113,3 x 204,5 x 22,35 mm (hauteur x largeur x profondeur)'
          }, {
            key: 'Poids net',
            value: '450 g'
          }, {
            key: 'Tests et certifications',
            value: 'CE, UL, FCC, EMC Classe B'
          }]
        }
      },
      // {
      //     comboSubId: 'combo_2_sub_3',
      //     name: 'Smart Generator',
      //     desc: `Dans les cas extrêmes, vous pouvez utiliser le Smart Generator pour une alimentation de secours. Il est jusqu'à 25 % plus efficace que les autres générateurs, ce qui vous permet d'économiser du combustible, de limiter les émissions de fumées et de gagner du temps.`,
      //     img: '/img/calculators/mm100/combo-generator.jpg',
      //     imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
      //     details: {
      //         title: 'Smart Generator',
      //         desc: `Dans les cas extrêmes, vous pouvez utiliser le Smart Generator pour une alimentation de secours. Il est jusqu'à 25 % plus efficace que les autres générateurs, ce qui vous permet d'économiser du combustible, de limiter les émissions de fumées et de gagner du temps.`,
      //         img: '/img/calculators/mm100/combo-detail-generator.jpg',
      //         imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
      //         specParams: [
      //             { key: 'Poids net', value: '29,3 kg' },
      //             { key: 'Dimensions', value: '59,7 x 29,6 x 47,5 cm' },
      //             { key: 'Tension nominale', value: '230 V' },
      //             { key: 'Type', value: 'Générateur à onduleur' },
      //             { key: 'Fréquence', value: '50Hz / 60Hz' },
      //             { key: 'Puissance de sortie nominale', value: '1800 W (crête 1900 W)' },
      //             { key: 'Type de combustible', value: 'Carburant sans plomb' },
      //             { key: 'Volume du réservoir de carburant', value: '4 litres' },
      //             { key: 'Temps de fonctionnement continu', value: '3,5 h (pleine charge)' },
      //         ]
      //     }
      // },
      {
        comboSubId: 'combo_2_sub_4',
        name: 'Sangle de montage de batterie',
        desc: 'Installez vos batteries en toute sécurité.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '7773575545058',
      variantId: '43013376737506',
      name: '2*Panneaux Solaires Rigides 100W + 2*Pieds de montage',
      discountPrice: 179,
      originalPrice: 229,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*Panneaux Solaires Rigides 100W + 2*Pieds de montage',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: 'Puissance nominale',
          value: '100 W (+/-5 W)'
        }, {
          key: 'Tension de circuit ouvert',
          value: '20,3 V'
        }, {
          key: 'Courant de court-circuit',
          value: '6,3 A'
        }, {
          key: "Tension d'utilisation maximale",
          value: '17,1 V'
        }, {
          key: 'Courant de fonctionnement maximum',
          value: '5,9 A'
        }, {
          key: 'Coefficient de température de la puissance nominale',
          value: '-0,39 %/°C'
        }, {
          key: 'Coefficient de température de tension de circuit ouvert',
          value: '-0,33 %/°C'
        }, {
          key: 'Coefficient de température du courant de court-circuit',
          value: '0,06 %/°C'
        }, {
          key: 'Tension maximale du système',
          value: '600 VCC (UL)'
        }, {
          key: 'Courant maximal du fusible',
          value: '15 A'
        }, {
          key: 'Poids du panneau solaire',
          value: 'Environ 6,2 kg'
        }, {
          key: 'Dimensions',
          value: '98 x 58,6 x 3 cm'
        }]
      },
      question: {}
    }, {
      productId: '7773575643362',
      variantId: '43013376868578',
      name: '2*Panneau Solaire Rigide 400W + 4*Pieds de montage',
      discountPrice: 599,
      originalPrice: 799,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 800,
      // freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*Panneau Solaire Rigide 400W + 4*Pieds de montage',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: 'Puissance nominale',
          value: '400 W (+/-3 W)'
        }, {
          key: 'Tension de circuit ouvert',
          value: '37,1 V'
        }, {
          key: 'Courant de court-circuit',
          value: '13,79 A'
        }, {
          key: "Tension d'utilisation maximale",
          value: '31,00 V'
        }, {
          key: 'Courant de fonctionnement maximum',
          value: '12,90 A'
        }, {
          key: 'Coefficient de température de la puissance nominale',
          value: '-0,38 %/°C'
        }, {
          key: 'Coefficient de température de tension de circuit ouvert',
          value: '-0,35 %/°C'
        }, {
          key: 'Coefficient de température du courant de court-circuit',
          value: '+0,06 %/°C'
        }, {
          key: 'Tension maximale du système',
          value: '1500 VCC'
        }, {
          key: 'Courant maximal du fusible',
          value: '25 A'
        }, {
          key: 'Température de fonctionnement',
          value: '-25 °C- +50 °C'
        }, {
          key: 'Poids du panneau solaire',
          value: 'Environ 21,8 kg'
        }, {
          key: 'Dimensions',
          value: '1722 × 1134 × 35 mm'
        }]
      },
      question: {}
    }, {
      productId: '7773575676130',
      variantId: '43013376934114',
      name: '1*Panneau Solaire Flexible 100W',
      discountPrice: 129,
      originalPrice: 149,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*Panneau Solaire Flexible 100W',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: 'Puissance nominale',
          value: '100 W (+/-5 W)'
        }, {
          key: 'Tension de circuit ouvert',
          value: '20,3 V'
        }, {
          key: 'Courant de court-circuit',
          value: '6,3 A'
        }, {
          key: "Tension d'utilisation maximale",
          value: '17,1 V'
        }, {
          key: 'Courant de fonctionnement maximum',
          value: '5,9 A'
        }, {
          key: 'Coefficient de température de la puissance nominale',
          value: '-0,39 %/°C'
        }, {
          key: 'Coefficient de température de tension de circuit ouvert',
          value: '-0,33 %/°C'
        }, {
          key: 'Coefficient de température du courant de court-circuit',
          value: '0,06 %/°C'
        }, {
          key: 'Tension maximale du système',
          value: '600 VCC (UL)'
        }, {
          key: 'Courant maximal du fusibl',
          value: '15 A'
        }, {
          key: 'Poids du panneau solaire',
          value: 'Environ 2,3 kg'
        }, {
          key: 'Dimensions',
          value: '1055 x 612 x 25 mm'
        }]
      },
      question: {}
    }, {
      productId: '6618094960713',
      variantId: '39998021697609',
      name: '1*400W portable solar panel',
      discountPrice: 1199,
      originalPrice: 1199,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 400,
      locale: ['us', 'ca', 'au', 'jp'],
      // only for us site
      img: '/img/calculators/mm100/solar-400-portable.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*400W Portable Solar Panel',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
        specParams: [{
          key: 'Rated Power',
          value: '400W(+/-10W)'
        }, {
          key: 'Open Circuit Voltage',
          value: '48V(Vmp 41V)'
        }, {
          key: 'Short Circuit Current',
          value: '11A(Imp 9.8A)'
        }, {
          key: 'Efficiency',
          value: '22.4 %'
        }, {
          key: 'Cell Type',
          value: 'Monocrystalline silicon'
        }, {
          key: 'Connector type',
          value: 'MC4'
        }, {
          key: 'Weight',
          value: '46.3 lbs(21.0KG)'
        }, {
          key: 'Solar Panel',
          value: '33.1lbs(15.0KG)'
        }, {
          key: 'Unfolded Dimensions',
          value: '42.0 * 94.1 * 1.0 in (106.8 * 239.0 * 2.4cm)'
        }, {
          key: 'Folded Dimensions',
          value: '42.0 * 24.4 * 1.0 in (106.8 * 62.0 * 2.4cm)'
        }]
      },
      question: {}
    }],
    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      43013375787234: 'power-2kw.jpg',
      43013375820002: 'bundle-2kw-dp.jpg',
      43013375852770: 'bundle-2kw-all_us.jpg',
      43013375918306: 'power-4kw.jpg',
      43013375951074: 'bundle-4kw-dp.jpg',
      43013375983842: 'bundle-4kw-all_us.jpg',
      43013376278754: 'power-5kw.jpg',
      43013376311522: 'bundle-5kw-dp.jpg',
      43013376344290: 'bundle-5kw-all_us.jpg',
      43013376409826: 'power-10kw.jpg',
      43013376442594: 'bundle-10kw-dp.jpg',
      43013376475362: 'bundle-10kw-all_us.jpg',
      43013376540898: 'power-15kw.jpg',
      43013376573666: 'bundle-15kw-dp.jpg',
      43013376606434: 'bundle-15kw-all_us.jpg'
    },
    // solar price discount rate
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      7773575184610: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7773575250146: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7773575315682: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7773575381218: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7773575446754: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      }
    },
    // common power kit's details
    powerDetails: {
      title: 'EcoFlow Power Hub ',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: "Le Power Hub est le c\u0153ur de votre Kit \xC9nergie et permet d'\xE9conomiser de la place dans votre van ou votre construction hors r\xE9seau. Le Power Hub est l'\xE9quivalent de deux contr\xF4leurs de charge solaire MPPT, d'un chargeur de batterie avec MPPT, d'un convertisseur abaisseur DC/DC et d'un onduleur-chargeur, le tout dans une seule unit\xE9, pour une configuration d'une grande simplicit\xE9.",
      specParams: [{
        key: 'Poids net',
        value: '14 kg'
      }, {
        key: 'Dimensions',
        value: '30 x 48 x 14 cm (hauteur x largeur x profondeur)'
      }, {
        key: 'Tests et certifications ',
        value: 'CE, UL, FCC'
      }, {
        key: 'WI-FI',
        value: 'Pris en charge'
      }, {
        key: 'Bluetooth',
        value: 'Pris en charge'
      }, {
        key: 'Puissance de sortie principale CA/fréquence',
        value: 'Onde sinusoïdale pure, 3600 W (surtension de 6000 W), 230 V, 50 Hz/60 Hz'
      }, {
        key: 'Puissance de sortie principale CC',
        value: '13,6 V/70 A 1000 W max ; 26,4 V/60 A, 1 500 W max'
      }, {
        key: "Puissance d'entr\xE9es principale CA",
        value: 'Charge rapide X-Stream 3000 W max, 16 A max'
      }, {
        key: "Tension d'entr\xE9es principale CA/Fr\xE9quence",
        value: '220-240 V, 50 Hz / 60 Hz'
      }, {
        key: 'Entrées de charge solaire',
        value: '15-150 V 30 A, 1600 W max'
      }, {
        key: 'Entrées de charge alternateur',
        value: '13 V-60 V, 60 A, 1000 W max'
      }, {
        key: 'Température de fonctionnement optimale',
        value: '20°C - 30°C'
      }, {
        key: 'Température de décharge',
        value: '-25°C - 60°C'
      }, {
        key: 'Température de charge',
        value: '-25°C - 60°C'
      }, {
        key: 'Température de stockage',
        value: '-25°C - 60°C'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: "L'augmentation de la dur\xE9e de fonctionnement a \xE9t\xE9 calcul\xE9e sur la base d'une moyenne de 80 % de l'apport du panneau solaire et de 5 heures de lumi\xE8re du soleil."
    },
    // // installations
    // installOptions: [
    //     {
    //         variantId: 0,
    //         i18n: 'self',
    //     },
    //     {
    //         productId: '7773575708898',
    //         variantId: '43013376966882',
    //         i18n: 'expert',
    //         i18n_des: 'pro',
    //     },
    // ],

    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: true,
    wire: {
      name: 'Jeu de câbles + Sangle de montage de batterie'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};